<template>
    <div v-resized="resized" class="route-analyzer d-flex flex-column flex-md-row">
        <golia-loader v-show="isLoading || loadingPrint" :message="__('loading')"></golia-loader>

        <VueHtml2pdf :show-layout="false" :float-layout="true" :enable-download="true" :preview-modal="true"
            :paginate-elements-by-height="1400" :filename="__('geofleet.analyzer.vehicle_activity_analisys') +
                ' ' +
                (truck.details.custom_id || truck.plate)
                " :pdf-quality="2" :manual-pagination="false" pdf-format="a4" pdf-orientation="portrait"
            pdf-content-width="800px" ref="html2Pdf">
            <section class="mx-auto p-5" slot="pdf-content">
                <div class="row">
                    <div class="col-lg-6">
                        <!-- PDF Content Here -->
                        <h3 class="targa-f">{{ truck.details.custom_id || truck.plate }}</h3>

                        <div v-if="truck.details.custom_id" class="plate">
                            <small>{{ truck.plate }}</small>
                        </div>
                    </div>
                    <div class="col-lg-6 text-right">
                        <img class="golia-logo img-fluid d-block ms-auto"
                            src="data:image/png;base64,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" />
                    </div>
                </div>

                <img class="my-5 img-fluid" :src="screenshot" />

                <div class="print-recap">
                    <div class="title mb-4">
                        <i class="fa-solid fa-book"></i>&nbsp;{{ __('recap') }}
                    </div>

                    <div class="info" v-if="routeTimeline && routeTimeline.recap">
                        <div>
                            <b>{{ __('start') }}</b>:
                            {{ moment(routeTimeline.recap.start_date, 'UTC').format('L HH:mm:ss') }}
                        </div>
                        <reverse-geocoding class="reverse-address" :full="true"
                            :latLon="routeTimeline.recap.extremes[0]" />
                        <div class="mt-3">
                            <b>{{ __('end') }}</b>:
                            {{ moment(routeTimeline.recap.end_date, 'UTC').format('L HH:mm:ss') }}
                        </div>
                        <reverse-geocoding class="reverse-address" :full="true"
                            :latLon="routeTimeline.recap.extremes[1]" />
                        <div class="mt-3">
                            <b>{{ __('duration') }}</b>: {{ parseInt(routeTimeline.recap.duration) | minutesToTime }} h
                        </div>
                        <div v-if="routeTimeline.recap.distance">
                            <b>{{ __('distance') }}</b>: {{ routeTimeline.recap.distance.toFixed(2) }} Km
                        </div>
                        <div v-if="routeTimeline.recap.gps_distance">
                            <b>{{ __('gps_distance') }}</b>: {{ routeTimeline.recap.gps_distance.toFixed(2) }} Km
                        </div>
                        <div v-if="routeTimeline.recap.fuel_consumption" class="d-none">
                            <b>{{ __('fuel_consumption') }}</b>: {{ routeTimeline.recap.fuel_consumption.toFixed(2) }} l
                        </div>
                    </div>
                </div>
            </section>
        </VueHtml2pdf>

        <div class="chart-map">
            <!-- Activity panel settings -->
            <div class="d-flex justify-content-between align-items-center">
                <span class="font-bold">{{ __('telemetry') }}</span>
                <div class="d-flex align-items-center gap-3">
                    <golia-button :label="__('settings')" icon="fa-regular fa-gear" class="p-0"
                        v-b-modal.chart-settings-modal />
                </div>
            </div>
            <!-- Activity panel settings modal -->
            <b-modal id="chart-settings-modal" :title="__('settings')" size="lg" body-class="custom-scrollbar"
                scrollable>
                <analyze-page-config @savedSettings="handleSavedSettings" />
            </b-modal>

            <!-- Chart -->
            <div class="activity-chart no-data bg-main-gray text-center d-flex align-items-center justify-content-center"
                v-if="!isLoading && !routeLoaded && storeGeoJson.length > 0">
                <div>
                    <i class="fa-solid fa-info-circle me-3"></i>
                    <span>{{ __('analisys.no_data') }}</span>
                    <p class="mb-0 mt-2 text-muted text-smaller">
                        {{ __('analisys.no_data_description') }}
                        <br />
                        <br />
                        <a class="text-golia" href="mailto:support@infogestweb.it">{{
                            __('analisys.no_data_contact_support')
                            }}</a>
                    </p>
                </div>
            </div>
            <activity-chart class="activity-chart" :layers="layers" :activities="activities" :extremes="extremes"
                ref="activityChart" v-else-if="$mq !== 'xs' && $mq !== 'sm'" />

            <!-- Map -->
            <geofleet-map class="geofleet-map smaller-controls" :map="this.map.map" :advanced="this.map.advanced"
                :cluster="this.map.cluster" :ptvToken="this.$env.ptv_password" :trucks="trucks"
                :noAutoCenterMap="($mq != 'xs' && $mq != 'sm') || showRouteAction" :minimal="$mq == 'xs' || $mq == 'sm'"
                :gestureHandling="$mq == 'xs' || $mq == 'sm'" :poi="true" ref="map">
                <l-geo-json @ready="geoJsonLoaded" v-for="opt in geojson" :key="opt.id" :geojson="opt.geojson"
                    :optionsStyle="opt.style || {}" :options="opt.options || {}" :ref="'geojson_' + opt.id" />
                <!-- Start and Finish markers -->
                <custom-marker id="start" v-if="routeTimeline?.recap?.extremes"
                    :coordinates="routeTimeline?.recap?.extremes[0]" :markerTitle="__('start')" :iconUnicode="'#xf11e'"
                    :customizer="{ tiny: true, color_class: 'start' }" />

                <custom-marker id="end" v-if="routeTimeline?.recap?.extremes"
                    :coordinates="routeTimeline?.recap?.extremes[1]" :markerTitle="__('finish_point')"
                    :iconUnicode="'#xf11e'" :customizer="{ tiny: true, color_class: 'finish' }" />
            </geofleet-map>
        </div>

        <!-- Timeline -->
        <div class="timeline-wrapper" id="timeline-wrapper" v-if="layers.length">
            <!-- Tachograph activities -->
            <div class="tachograph-activities" v-if="hasTachographData">
                <div class="container-fluid">
                    <div class="px-0 px-md-4">
                        <button
                            type="button"
                            class="tacho-title-button"
                            v-b-tooltip.hover.top="tachographTooltip"
                            @click="openTachographActivities()"
                        >
                            <i class="fa-regular fa-gauge-high me-2 text-muted"></i>
                            <span class="font-bold">{{ __('tachograph_activities') }}</span>
                            <i class="fa-regular fa-circle-info tacho-title-button-info ms-2"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="timeline-tools">
                <div class="container-fluid">
                    <div class="px-0 px-md-4">
                        <div class="d-flex justify-content-between align-items-center">
                            <span class="font-bold">{{ __('Timeline') }}</span>
                            <golia-button :label="__('filters_label')" icon="fa-regular fa-filter" class="p-0"
                                id="timeline-filters" />
                            <b-popover target="timeline-filters" triggers="click blur" container="timeline-wrapper"
                                custom-class="timeline-filters-popover">
                                <template #title>{{ __('filters_label') }}</template>
                                <label for="timeline-break">{{
                                    __('analisys.stop_vehicle_minutes_separator')
                                    }}</label>
                                <golia-input v-model.number="timeline_break" type="number" :min="1" :max="60" :step="1"
                                    id="timeline-break" :placeholder="__('minutes')"
                                    @input="handleTimelineBreakInput" />
                            </b-popover>
                        </div>

                        <div class="row d-none">
                            <div :class="timeline_separator == 0 ? 'col-lg-6' : 'col-12'">
                                <golia-input v-model.number="timeline_separator" type="select"
                                    :options="[{ value: 0, text: __('break') }]" />
                            </div>
                            <div class="col-lg-6" v-if="timeline_separator == 0">
                                <golia-input v-model.number="timeline_break" type="number" :min="1" :max="60" :step="1"
                                    :placeholder="__('minutes')" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="timeline custom-scrollbar">
                <timeline :range="range" :truck="truck" :break="timeline_break" :type="timeline_separator"
                    :showRouteAction="showRouteAction" :stops="stops" v-model="routeTimeline" ref="timeline"
                    @selected="timelineSelected" @reset="reset" @print="print" />
            </div>
        </div>
    </div>
</template>

<script>
    import { useAnalyzePageConfig } from '@/composables/useAnalyzePageConfig'
    import { debounce } from 'lodash'
    import L from 'leaflet'
    import 'leaflet-arrowheads'

    import { LGeoJson } from 'vue2-leaflet'
    import ActivityChart from './ActivityChart.vue'
    import Timeline from './Timeline.vue'

    import { SimpleMapScreenshoter } from 'leaflet-simple-map-screenshoter'
    import VueHtml2pdf from 'vue-html2pdf'

    import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

    import goliaLegacyLinks from '@/mixins/goliaLegacyLinks'

    /** Shown when a telemetry is selected but this point has no usable reading. */
    const NO_VALUE = '—'

    export default {
        name: 'MapRouteAnalizer',
        mixins: [goliaLegacyLinks],
        props: {
            truck: {
                type: Object,
                required: true
            },
            map: {
                type: Object,
                default: () => {
                    return {
                        map: 'silica',
                        advanced: true,
                        cluster: true
                    }
                }
            },
            range: {
                type: Object,
                required: false
            },
            timeline: {
                type: Object,
                selected: true
            },
            showRouteAction: {
                type: Boolean,
                default: false
            }
        },
        setup(props) {
            // Merged selections (stored flags over the full defaults). We need the MERGED
            // shape, not the raw stored blob: only `{active, extension}` is persisted, so
            // the raw blob has no `chartUm`/`group` and units would be lost.
            const { selection: chartSelection } = useAnalyzePageConfig('chart')
            const { selection: mapSelection } = useAnalyzePageConfig('mapTelemetries')

            return {
                chartSelection,
                mapSelection
            }
        },
        components: {
            LGeoJson,
            ActivityChart,
            Timeline,
            VueHtml2pdf
        },
        data() {
            return {
                geojson: [],

                layers: [],
                activities: [],
                stops: [],
                routeDirectionMinZoom: 16,
                extremes: null,

                ends: { start: null, end: null },
                counter: 0,

                screenShooter: null,
                screenshot: null,
                loadingPrint: false,
                loadingTimeout: false,
                timeout: null,

                timeline_separator: 0,
                timeline_break: 15,
                routeTimeline: {},

                debounceTimeout: null,
                isInitializing: true
            }
        },
        created() {
            // Se è da mobile non precarico il percorso di default, ma aspetto un azione esplicita
            if (this.$mq != 'xs' && this.$mq != 'sm') {
                this.draw()
            }

            // Config Bus (Sprint 18, REFACTOR-030): lettura granulare per-chiave via
            // getter `value(key)` (default da schema: 0 / 15) al posto dei default inline.
            this.timeline_separator = this.$store.getters['config/value']('timeline_separator')
            this.timeline_break = this.$store.getters['config/value']('timeline_break')

            // Store watcher references
            this.watchers = {
                showRouteAction: this.$watch('showRouteAction', this.handleShowRouteAction),
                truck: this.$watch('truck', this.handleTruckChange, { deep: true }),
                range: this.$watch('range', this.handleRangeChange, { deep: true })
            }
        },
        mounted() {
            this.$nextTick(() => {
                if (this.$refs.map.lmap) {
                    this.screenShooter = new SimpleMapScreenshoter().addTo(this.$refs.map.lmap)
                    this.$refs.map.lmap.on('zoomend', this.handleRouteDirectionZoom)
                }
            })
        },
        beforeDestroy() {
            // Clean up existing handlers
            this.resetActivityPanel()
            this.resetData()

            // Add these cleanup steps:
            if (this.$refs.map?.lmap) {
                // Remove all layers
                this.layers.forEach((layer) => {
                    // Remove event listeners
                    layer.off('mouseover')
                    layer.off('mouseout')
                    layer.off('click')
                    layer.off('popupclose')
                    layer.off('popupopen')

                    // Remove from map
                    layer.remove()
                })

                // Clear references
                this.layers = []
                this.activities = []
                this.stops = []
                this.geojson = []
            }

            // Clear any pending timeouts
            if (this.timeout) {
                clearTimeout(this.timeout)
            }

            // Add VueHtml2pdf cleanup
            if (this.$refs.html2Pdf) {
                this.$refs.html2Pdf.$destroy()
                this.$refs.html2Pdf = null
            }

            // Remove screenshooter
            if (this.screenShooter) {
                this.screenShooter.remove()
                this.screenShooter = null
            }

            if (this.$refs.map?.lmap) {
                this.$refs.map.lmap.off('zoomend', this.handleRouteDirectionZoom)
            }

            // Clear screenshot data
            this.screenshot = null

            // Clean up timeline
            if (this.$refs.timeline) {
                this.$refs.timeline.$off() // Remove all event listeners
                this.$refs.timeline = null
            }

            // Unwatch all watchers
            Object.values(this.watchers).forEach((unwatch) => unwatch())
        },
        watch: {
            showRouteAction: {
                handler(newVal) {
                    if (newVal) {
                        this.draw()
                    } else {
                        this.resetData()
                    }
                },
                immediate: false // Only run when actually changes
            },

            truck: {
                handler(newT, oldT) {
                    if (newT.id === oldT?.id) return

                    this.resetData()
                    this.draw()
                },
                deep: true
            },
            // RIMOSSO PERCHE' DUPLICATO
            // range: {
            //     handler() {
            //         this.resetData()
            //         this.draw()
            //     },
            //     deep: true
            // },

            // Remove unnecessary watches if possible
            timeline_break: {
                handler() {
                    // Config Bus (Sprint 18, REFACTOR-030): commitChange granulare.
                    this.$store.dispatch('config/commitChange', {
                        key: 'timeline_break',
                        value: this.timeline_break
                    })

                    // Only redraw stops if needed and not during initialization
                    // if (this.stops.length && !this.isInitializing) {
                    //     this.debouncedDrawStops()
                    // }
                }
            },
            timeline_separator() {
                // Config Bus (Sprint 18, REFACTOR-030): commitChange granulare.
                this.$store.dispatch('config/commitChange', {
                    key: 'timeline_separator',
                    value: this.timeline_separator
                })
            },
            routeTimeline: {
                handler(newVal, oldVal) {
                    // Quando routeTimeline viene popolato, disegna gli stops
                    // Solo se timeline è presente e non è vuota, e se è cambiata rispetto a prima
                    if (
                        newVal &&
                        newVal.timeline &&
                        newVal.timeline.length > 0 &&
                        (!oldVal || !oldVal.timeline || oldVal.timeline.length === 0)
                    ) {
                        this.drawStops()
                    }
                },
                deep: true
            }
            // 'config.chart': {
            //     handler(newVal, oldVal) {
            //         // Solo se la proprietà chart esiste davvero
            //         console.log(newVal, oldVal)
            //         if (this.config && 'chart' in this.config) {
            //             // Only trigger after component is fully initialized
            //             if (!this.isInitializing) {
            //                 this.draw()
            //             }
            //         }
            //     },
            //     deep: true
            // }
        },
        computed: {
            trucks() {
                return [this.truck]
            },
            hasTachographData() {
                // Il tachigrafo è disponibile solo se il veicolo ha effettivamente
                // caricato un file DDD. `this.moment` (Dater) ritorna null per date
                // non valide/vuote (es. null, "" o "0000-00-00 00:00:00"): basta
                // quindi verificarne la truthiness. Il guard su `upload` è necessario
                // perché `this.moment(undefined)` restituirebbe la data corrente.
                const upload = this.truck?.details?.ddd_last_upload
                return !!upload && !!this.moment(upload)
            },
            tachographTooltip() {
                const start = this.range?.start ? this.range.start.format('L') : ''
                const end = this.range?.end ? this.range.end.format('L') : ''
                return `${this.__('tachograph_activities_period_hint')} ${start} - ${end}`
            },
            startDate() {
                return this.range.start ? this.range.start.clone().utc().toISOString() : false
            },
            endDate() {
                return this.range.end ? this.range.end.clone().utc().toISOString() : false
            },
            /**
             * Telemetries selected for the CHART ("Chart settings" tab).
             * Drives the activity band fed to <activity-chart> via `this.activities`.
             *
             * Config Bus (Sprint 18, REFACTOR-030): `chart` resta lettura RAW dal blob (via
             * `useAnalyzePageConfig`, che fa il merge coi default locali). Lo schema NON
             * centralizza `chart` (tre strutture divergenti, vedi decision Sprint 18) →
             * niente `value('chart')`.
             */
            activeChartTelemetries() {
                return this.selectActiveTelemetries(this.chartSelection)
            },
            /**
             * Telemetries selected for the MAP ("Map settings" tab).
             * Drives the point popups and hover tooltips.
             *
             * Users who never opened the new tab have no `mapTelemetries` key yet — the
             * fallback onto `chart` lives inside `useAnalyzePageConfig`.
             */
            activeMapTelemetries() {
                return this.selectActiveTelemetries(this.mapSelection)
            },
            computedStops() {
                if (this.routeTimeline) {
                    return this.routeTimeline?.timeline?.filter((element) => {
                        return element.type == 'stop'
                    })
                } else {
                    return []
                }
            },
            loading() {
                return this.counter > 0 || this.loadingPrint
            },
            ...mapState({
                storeGeoJson: (state) => state.activityPanel.geojson
            }),
            ...mapGetters({
                isLoading: 'activityPanel/isLoading',
                allResourcesLoaded: 'activityPanel/allResourcesLoaded',
                routeLoaded: 'activityPanel/routeLoaded',
                stopsLoaded: 'activityPanel/stopsLoaded',
                activitiesLoaded: 'activityPanel/activitiesLoaded'
            })
        },
        methods: {
            /**
             * Flattens a telemetry selection into the `[{ key, value }]` shape the popup /
             * tooltip / chart builders expect, keeping only the active entries.
             */
            selectActiveTelemetries(selection) {
                return Object.entries(selection).reduce((active, [key, value]) => {
                    if (value?.active) active.push({ key, value })
                    return active
                }, [])
            },
            handleSavedSettings() {
                // close modal
                this.$bvModal.hide('chart-settings-modal')
                this.draw()
            },
            openTachographActivities() {
                // Usa l'intervallo di date selezionato nella pagina di analisi
                const dataDal = this.range.start.format('YYYY-MM-DD')
                const giorni = Math.max(this.range.end.diff(this.range.start, 'days') + 1, 1)

                this.openGoliaTachographActivities({
                    vehicleId: this.truck?.id,
                    dataDal,
                    giorni
                })
            },
            handleTimelineBreakInput: debounce(function (value) {
                if (this.stops.length) {
                    this.drawStops(value)
                }
            }, 2000),
            /**
             * True when `key` is one of the telemetries picked in the "Map settings" tab.
             */
            isMapTelemetrySelected(key) {
                return this.activeMapTelemetries.some((data) => data.key === key)
            },
            /**
             * Formats one selected telemetry for display, unit included. Shared by the hover
             * tooltip and the point popup so both honour the same selection and formatting.
             * Returns null when this point carries no value for the field.
             */
            formatTelemetryValue(data, origin, consumption, distance) {
                // `consumption` and `distance` are accumulated while drawing the route, so
                // they are passed in rather than read off the point.
                let value = origin[data.key]

                if (data.key == 'consumption') value = consumption
                else if (data.key == 'distance') value = distance

                // Nothing recorded for this field at this point: drop the row entirely.
                if (value === undefined || value === null) return null

                // Present but unusable: '' or a non-numeric string from the API, or the NaN
                // the accumulators produce from a bad reading. Every field here is a numeric
                // telemetry, so anything Number() can't resolve has nothing to show — mark it
                // selected-but-empty rather than printing "NaN l". Note Number('') is 0,
                // hence the explicit blank check.
                const numeric = typeof value === 'string' && value.trim() === '' ? NaN : Number(value)

                if (!Number.isFinite(numeric)) return NO_VALUE

                value = numeric

                if (data.key == 'odometer' || data.key == 'gps_odometer') {
                    value = new Intl.NumberFormat(this.$store?.loggedUser?.params?.Lingua, {
                        maximumFractionDigits: 0
                    }).format(value)
                } else if (data.key == 'activity') {
                    if (value === 0) value = this.__('rest')
                    else if (value === 1) value = this.__('availability')
                    else if (value === 2) value = this.__('work')
                    else if (value === 3) value = this.__('driving')
                } else if (data.key == 'distance') {
                    // Keeps its decimals: parseInt would render a 0.8 Km accumulation as "0 Km".
                    value = value.toFixed(2)
                } else if (data.value.chartUm) {
                    value = parseInt(value)
                }

                // Guarded: `__(undefined)` returns null, which would print "12.34 null".
                if (data.value.chartUm) value = value + ' ' + this.__(data.value.chartUm)

                return value
            },
            buildTooltip(origin, consumption, distance) {
                let date = this.moment(origin.date, 'UTC')
                let heading = origin.heading

                const tachoSpeedIsPresent = this.isMapTelemetrySelected('tacho_speed')

                origin.timestamp = date.unix()

                let tooltip =
                    '<div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">'
                tooltip +=
                    '<div style="display: flex;flex-direction: row;justify-content: center;align-items: center;gap: 5px;">'

                if (heading)
                    tooltip +=
                        '<div style="flex-grow: 2;"><svg style="height: 22px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 595 615"><g style="transform: rotate(' +
                        String(heading) +
                        'deg); transform-origin: center;"><path d="M267.6,83.5,113,499c-17.7,48.1,41.3,85.5,76.5,50.6L310.3,429.5l120,120.9c34.9,35.1,94.2-1.9,76.8-50.1L355.2,83.8C340,46.5,283,46.3,267.6,83.5Z" transform="translate(-10 -25)"/></g></svg></div>'

                tooltip +=
                    '<div style="display: flex;flex-direction: column;justify-content: flex-start;">'

                // Speed keeps its bespoke dual rendering: when the tacho speed is also
                // selected the two lines are disambiguated as (GPS) and (tacho).
                if (this.isMapTelemetrySelected('speed') && origin.speed)
                    tooltip +=
                        '<span>' +
                        origin.speed +
                        (tachoSpeedIsPresent ? ' km/h (GPS)</span>' : ' km/h</span>')

                if (tachoSpeedIsPresent && origin.tacho_speed)
                    tooltip += '<span>' + origin.tacho_speed + ' km/h (tacho)</span>'

                // Every other selected telemetry, formatted exactly as in the popup.
                this.activeMapTelemetries.forEach((data) => {
                    if (data.key == 'speed' || data.key == 'tacho_speed') return

                    const value = this.formatTelemetryValue(data, origin, consumption, distance)

                    // The tooltip prints bare values with no field labels, so a lone
                    // placeholder would be unreadable — only the popup renders those.
                    if (value === null || value === NO_VALUE) return

                    tooltip += '<span>' + value + '</span>'
                })

                tooltip += '</div>'
                tooltip += '</div>'
                tooltip += '<span>' + date.format('L HH:mm:ss') + '</span>'
                tooltip += '</div>'

                return tooltip
            },
            buildPopup(origin, address, consumption, distance) {
                let date = this.moment(origin.date, 'UTC')

                let popup = '<span>' + date.format('L HH:mm:ss') + '</span>'

                popup += '<div class="address-container mt-1">'
                popup +=
                    '<span><i class="fa-solid fa-location-dot float-left me-1"></i>' +
                    address +
                    '</span>'
                popup += '</div><hr class="my-3"/>'

                popup += '<div class="data-container">'

                this.activeMapTelemetries.forEach((data) => {
                    const value = this.formatTelemetryValue(data, origin, consumption, distance)

                    if (value === null) return

                    popup +=
                        '<b class="font-bold">' +
                        this.__(data.key) +
                        ': </b>' +
                        '<span>' +
                        value +
                        '</span>'
                })

                popup += '</div>'

                return popup
            },
            cleanupLayers() {
                if (!this.$refs.map?.lmap) return

                // Clean up each layer
                this.layers.forEach((layer) => {
                    if (typeof layer.deleteArrowheads === 'function') {
                        layer.deleteArrowheads()
                    }

                    // Remove event listeners
                    if (layer.eventHandlers) {
                        Object.keys(layer.eventHandlers).forEach((event) => {
                            layer.off(event, layer.eventHandlers[event])
                        })
                        delete layer.eventHandlers
                    }

                    // Remove popups
                    if (layer.getPopup()) {
                        layer.unbindPopup()
                    }

                    // Remove tooltips
                    if (layer.getTooltip()) {
                        layer.unbindTooltip()
                    }

                    // Remove from map
                    if (layer.remove) {
                        layer.remove()
                    }

                    // Clear any custom properties
                    if (layer.feature) {
                        delete layer.feature
                    }
                })

                // Clear arrays and references
                this.layers = []
                this.activities = []
                this.stops = []
                this.geojson = []

                // Clear any map references
                if (this.$refs.map?.lmap) {
                    this.$refs.map.lmap.eachLayer((layer) => {
                        if (layer instanceof L.GeoJSON) {
                            layer.remove()
                        }
                    })
                }
            },
            resetData() {
                this.reset()
                this.routeTimeline = {}

                // Use cleanup method
                this.cleanupLayers()

                if (this.$refs.map?.lmap) {
                    this.$refs.map.lmap.setView(
                        [this.truck?.lastpoint?.lat, this.truck?.lastpoint?.lng],
                        13
                    )
                }
            },
            reset() {
                if (this.layers.length == 0) return false

                this.layers.map((layer) => {
                    let original_style = this.getLayerOriginalStyle(layer, false, false)

                    layer.original_style = original_style

                    layer.setStyle(original_style)
                })

                let map_bounds = this.$refs?.geojson_route
                    ? this.$refs?.geojson_route[0]?.mapObject.getBounds()
                    : []

                if (map_bounds && map_bounds.isValid()) this.$refs.map.lmap.fitBounds(map_bounds)

                this.extremes = null
            },
            getLayerOriginalStyle(layer, clicked, selected) {
                let speed = parseInt(
                    layer.feature.properties.tacho_speed || layer.feature.properties.speed
                )

                let color = '#fd3030'
                let weight = 7

                if (speed <= 30) color = '#5d8dc8' // Blue soft
                else if (speed <= 50) color = '#5d8dc8' // Blue soft
                else if (speed <= 70) color = '#5d8dc8' // Blue soft
                else if (speed <= 90) color = '#335e94' // Blue middle
                else if (speed <= 100) color = '#335e94' // Blue middle
                else if (speed <= 130) color = '#fda030' // Orange
                else color = '#fd3030'

                if (selected) {
                    weight = 12
                    color = '#ff8306'
                }

                return {
                    weight: weight,
                    color: color,
                    opacity: 1,
                    clicked: clicked || false,
                    selected: selected || false
                }
            },
            timelineSelected(info) {
                info.bound = info.bound || this.$refs.geojson_route[0].mapObject.getBounds()

                if (info.bound) this.$refs.map.lmap.fitBounds(info.bound)

                this.extremes = info.range

                this.layers.map((layer) => {
                    layer.original_style ? layer.setStyle(layer.original_style) : null

                    if (
                        info.range &&
                        layer.feature.properties.timestamp * 1000 >= info.range[0] &&
                        layer.feature.properties.timestamp * 1000 <= info.range[1]
                    ) {
                        layer.original_style = this.getLayerOriginalStyle(
                            layer,
                            layer.original_style,
                            true
                        )

                        layer.setStyle({
                            weight: 12,
                            color: '#ff8306'
                        })
                    }
                })
            },
            async getActivitiesTimeline(driver_id) {
                try {
                    if (!driver_id) return []

                    let res = await this.$fetch(
                        this.$env.GOLIA_API +
                        `/drivers/${driver_id}/activities?start_date=${this.range.start.toISOString()}&end_date=${this.range.end.toISOString()}`
                    )

                    res = await res.json()

                    return res.data.reduce((c, activity) => {
                        let period = this.moment(activity.period, 'UTC')

                        if (period.isSameOrAfter(this.range.end)) return c

                        let start_data = this.range.start.isAfter(period)
                            ? this.range.start.clone()
                            : period

                        let duration = period.clone().add(activity.duration, 'seconds')

                        if (duration.isSameOrBefore(this.range.start)) return c

                        let end_data = this.range.end.isBefore(duration)
                            ? this.range.end.clone()
                            : duration

                        c.push({
                            x: start_data.valueOf(),
                            x2: end_data.valueOf(),
                            activity: activity.activity,
                            ref: activity
                        })

                        return c
                    }, [])
                } catch (err) {
                    return []
                }
            },
            updateLayersFromRoute() {
                // Popola layers quando geojson_route è disponibile
                if (
                    this.$refs.geojson_route &&
                    this.$refs.geojson_route[0] &&
                    this.layers.length === 0
                ) {
                    this.layers = Object.values(this.$refs.geojson_route[0].mapObject._layers)
                    this.setLayers(this.layers)
                    this.updateRouteDirectionArrowheads()
                }
            },
            updateRouteDirectionArrowheads() {
                if (!this.$refs.map?.lmap) return
                const routeLayers = this.layers.filter(
                    (layer) =>
                        layer &&
                        typeof layer.getLatLngs === 'function' &&
                        layer.feature?.geometry?.type === 'LineString'
                )

                routeLayers.forEach((layer) => {
                    if (typeof layer.deleteArrowheads === 'function') {
                        layer.deleteArrowheads()
                    }

                    if (this.$refs.map.lmap.getZoom() < this.routeDirectionMinZoom) {
                        return
                    }

                    if (typeof layer.arrowheads === 'function') {
                        layer.arrowheads({
                            size: '15px',
                            frequency: '50px',
                            fill: true,
                            color: '#335e94',
                            weight: 2
                        })
                    }
                })
            },
            async geoJsonLoaded() {
                this.counter -= 1

                // Popola layers quando geojson_route è disponibile (non solo quando counter <= 0)
                this.updateLayersFromRoute()

                // Quando ho caricato tutto
                if (this.counter <= 0) {
                    let map_bound =
                        this.$refs.geojson_route && this.$refs.geojson_route[0]
                            ? this.$refs.geojson_route[0].mapObject.getBounds()
                            : null

                    if (map_bound && map_bound.isValid()) this.$refs.map.lmap.fitBounds(map_bound)

                    let driver_id = this.truck?.lastpoint?.driver?.id
                    // Activity band belongs to the CHART, so it follows the chart selection.
                    let settings = this.activeChartTelemetries
                        .filter((d) => d.key == 'activity')
                        .reduce((c, d) => {
                            c[d.key] = d
                            return c
                        }, {})

                    if (settings.activity && settings.activity.value.active) {
                        this.loadingPrint = true

                        this.activities =
                            settings.activity.value.extension?.computed && driver_id
                                ? await this.getActivitiesTimeline(driver_id)
                                : Object.values(this.$refs.geojson_activities[0].mapObject._layers).map(
                                    (activity) => {
                                        return {
                                            x: this.moment(
                                                activity.feature.properties.start_date,
                                                'UTC'
                                            ).valueOf(),
                                            x2: this.moment(
                                                activity.feature.properties.end_date,
                                                'UTC'
                                            ).valueOf(),
                                            activity: activity.feature.properties.activity,
                                            ref: activity
                                        }
                                    }
                                )

                        this.loadingPrint = false
                    } else {
                        this.activities = []
                    }

                    // Verifica che geojson_stops esista prima di accedervi
                    if (this.$refs.geojson_stops && this.$refs.geojson_stops[0]) {
                        this.stops = Object.values(this.$refs.geojson_stops[0].mapObject._layers)
                    }

                    // Assicurati che layers sia popolato
                    this.updateLayersFromRoute()

                    // Store sync
                    this.setActivities(this.activities)
                    this.setStops(this.stops)
                    this.setLayers(this.layers)

                    // Mark initialization as complete only when all async operations are done
                    this.isInitializing = false
                }
            },
            handleRouteDirectionZoom() {
                this.updateRouteDirectionArrowheads()
            },
            draw() {
                if (!(this.range.start && this.range.end)) return false

                if (this.truck) this.setCurrentTruck(this.truck)

                this.geojson = []
                // Counter a 2 perché drawStops() ora viene chiamato quando routeTimeline è disponibile (vedi watcher)
                this.counter = 2

                this.resetActivityPanel()

                this.drawRoute()
                // drawStops() ora viene chiamato quando routeTimeline è disponibile (vedi watcher)
                this.drawActivities()
            },
            drawRoute() {
                let lastpoint_company = this.truck?.lastpoint?.company

                let start_consumption_point = null
                let last_consumption_point = 0

                // Accumulated distance runs on the same principle as consumption: remember
                // the first odometer reading of the route and diff every later point against it.
                let start_distance_point = null
                let last_distance_point = 0

                this.setLoader({ route: true })

                this.$fetch(
                    this.$env.GOLIA_API +
                    '/geofleet/trucks/' +
                    this.truck.id +
                    '/route.json?start_date=' +
                    this.startDate +
                    '&end_date=' +
                    this.endDate +
                    '&company=' +
                    lastpoint_company
                )
                    .then((res) => {
                        return res.json()
                    })
                    .then((res) => {
                        this.setLoader({ route: false })

                        if (!res.features) return

                        this.ends = {
                            start: res.features?.at(0),
                            end: res.features?.at(-1)
                        }

                        const geoJsonToSave = {
                            id: 'route',
                            geojson: res,
                            style: (feature) => {
                                let speed = parseInt(
                                    feature.properties.tacho_speed || feature.properties.speed
                                )

                                let color = '#fd3030'

                                if (speed <= 30) color = '#5d8dc8' // Blue soft
                                else if (speed <= 50) color = '#5d8dc8' // Blue soft
                                else if (speed <= 70) color = '#5d8dc8' // Blue soft
                                else if (speed <= 90) color = '#335e94' // Blue middle
                                else if (speed <= 100) color = '#335e94' // Blue middle
                                else if (speed <= 130) color = '#fda030' // Orange
                                else color = '#fd3030'

                                return {
                                    weight: 7,
                                    color: color,
                                    opacity: 1
                                }
                            },
                            options: {
                                onEachFeature: async (feature, layer) => {
                                    let vm = this
                                    let address = null
                                    let consumption = null
                                    let distance = null

                                    // Address data
                                    let latLon = feature.geometry.coordinates[0]
                                    // address = await vm.$reverseGeocoding({
                                    //     lat: latLon[1],
                                    //     lng: latLon[0],
                                    //     full: this.full,
                                    //     raw: true
                                    // })

                                    // address = address.join(', ')

                                    // Consumption data
                                    if (
                                        this.activeMapTelemetries.find(
                                            (d) => d.key == 'consumption'
                                        )
                                    ) {
                                        // Number() first: a non-numeric reading is truthy, so
                                        // the bare `x || last` latched it and every later
                                        // point on the route then subtracted to NaN.
                                        const parsed = Number(feature.properties.fuel_total)
                                        const fuel_total =
                                            Number.isFinite(parsed) && parsed ? parsed : null

                                        if (start_consumption_point == null && fuel_total) {
                                            start_consumption_point = fuel_total
                                        }

                                        last_consumption_point = fuel_total || last_consumption_point

                                        consumption = parseFloat(
                                            (
                                                last_consumption_point - (start_consumption_point || 0)
                                            ).toFixed(2)
                                        )
                                    }

                                    // Distance data — Km covered from the start of the route
                                    // up to this point.
                                    if (
                                        this.activeMapTelemetries.find((d) => d.key == 'distance')
                                    ) {
                                        // Same latching guard as the consumption accumulator
                                        // above: skip unusable readings instead of adopting
                                        // them as the running total.
                                        const parsed = Number(
                                            feature.properties.odometer ||
                                            feature.properties.gps_odometer
                                        )
                                        const odometer =
                                            Number.isFinite(parsed) && parsed ? parsed : null

                                        if (start_distance_point == null && odometer) {
                                            start_distance_point = odometer
                                        }

                                        last_distance_point = odometer || last_distance_point

                                        distance = parseFloat(
                                            (
                                                last_distance_point - (start_distance_point || 0)
                                            ).toFixed(2)
                                        )
                                    }

                                    // Building tooltip — after the accumulators above, so the
                                    // hover hint can show consumption/distance like the popup.
                                    let tooltip = this.buildTooltip(
                                        feature.properties,
                                        consumption,
                                        distance
                                    )

                                    layer.bindTooltip(tooltip, {
                                        direction: 'right',
                                        offset: L.point(10, -40),
                                        interactive: true,
                                        className: 'leaflet-tooltip-custom'
                                    })

                                    // Building popup
                                    let popup = this.buildPopup(
                                        feature.properties,
                                        latLon,
                                        consumption,
                                        distance
                                    )

                                    layer.bindPopup(popup, {
                                        className: 'leaflet-popup-custom'
                                    })

                                    // Store event handler references for cleanup
                                    const handlers = {
                                        mouseover: function () {
                                            if (this.original_style?.clicked) return

                                            this.original_style = vm.getLayerOriginalStyle(
                                                this,
                                                this.original_style?.clicked,
                                                this.original_style?.selected
                                            )

                                            this.setStyle({
                                                weight: 14,
                                                color: '#35bdfc'
                                            })
                                        },

                                        mouseout: function () {
                                            if (!this.original_style?.clicked) {
                                                let original_style = vm.getLayerOriginalStyle(
                                                    this,
                                                    this.original_style?.clicked,
                                                    this.original_style?.selected
                                                )

                                                if (this.original_style) this.setStyle(original_style)
                                            }
                                        },

                                        click: function () {
                                            this.original_style = vm.getLayerOriginalStyle(this, true)
                                            this.setStyle({
                                                weight: 14,
                                                color: '#ffa500'
                                            })
                                        },

                                        popupclose: function () {
                                            if (this.original_style) this.setStyle(this.original_style)
                                            this.original_style.clicked = false
                                        },

                                        popupopen: async function () {
                                            address = await vm.$reverseGeocoding({
                                                lat: latLon[1],
                                                lng: latLon[0],
                                                full: this.full,
                                                raw: true
                                            })

                                            address = address.join(', ')

                                            // rebuild popup with address
                                            let popup = vm.buildPopup(
                                                feature.properties,
                                                address,
                                                consumption,
                                                distance
                                            )

                                            layer.setPopupContent(popup)
                                        }
                                    }

                                    // Attach handlers and store references
                                    layer.on(handlers)

                                    // Store handlers on layer for cleanup
                                    layer.eventHandlers = handlers
                                }
                            }
                        }

                        this.geojson = this.geojson.filter((g) => g.id != 'route')

                        this.geojson.push(geoJsonToSave)

                        this.setRouteGeoJSON(geoJsonToSave)

                        // Popola layers quando il route è disponibile
                        this.$nextTick(() => {
                            this.updateLayersFromRoute()
                        })
                    })
            },
            drawStops(withBreakOf = false) {
                // Verifica che routeTimeline sia disponibile e abbia la timeline
                if (!this.routeTimeline || !this.routeTimeline.timeline) {
                    return
                }

                // Filtra solo gli elementi di tipo "stop" dalla timeline
                const stops = this.routeTimeline.timeline.filter((element) => element.type === 'stop')

                if (stops.length === 0) return

                // Reset previous stops if exists
                let stopsIndex = this.geojson.findIndex((g) => g.id == 'stops')
                if (stopsIndex >= 0) this.geojson.splice(stopsIndex, 1)

                // Trasforma gli stop da routeTimeline in formato GeoJSON
                const features = stops.map((stop, index) => {
                    // Usa extremes[0] per la posizione del punto
                    const lat = stop.extremes[0].lat
                    const lon = stop.extremes[0].lon

                    // Formatta le date nel formato che si aspettava prima (YYYY-MM-DD HH:mm:ss)
                    const startDate = this.moment(stop.start_date, 'UTC').format('YYYY-MM-DD HH:mm:ss')
                    const endDate = this.moment(stop.end_date, 'UTC').format('YYYY-MM-DD HH:mm:ss')

                    return {
                        type: 'Feature',
                        properties: {
                            START_DATE: startDate,
                            END_DATE: endDate,
                            LATITUDE: lat,
                            LONGITUDE: lon,
                            DURATION: stop.duration,
                            index: stop.stop_index || index + 1
                        },
                        geometry: {
                            type: 'Point',
                            coordinates: [lon, lat]
                        },
                        stopsCount: stop.stop_index || index + 1
                    }
                })

                // Crea il GeoJSON
                const geoJsonData = {
                    type: 'FeatureCollection',
                    features: features
                }

                const geoJsonToSave = {
                    id: 'stops',
                    geojson: geoJsonData,
                    options: {
                        pointToLayer: (feature, latlng) => {
                            const stopMarker = L.marker(latlng, {
                                icon: L.divIcon({
                                    //html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 16"><defs><linearGradient id="myGradient"><stop offset="0%" stop-color="rgba(37,145,251,0.98)" /><stop offset="90%" stop-color="rgba(0,7,128,1)" /></linearGradient></defs><path stroke="white" stroke-width="0.4" d="M14.3,6.5a4.8,4.8,0,0,0-.7-2.3l.5-.5a.7.7,0,0,0,0-.9.7.7,0,0,0-1,0l-.4.4a5.2,5.2,0,0,0-2-.9V1.6H11a.6.6,0,0,0,.6-.6A.7.7,0,0,0,11,.3H9a.7.7,0,0,0-.6.7.6.6,0,0,0,.6.6h.3v.7A4.3,4.3,0,0,0,5.7,6.5a4.8,4.8,0,0,0,.4,1.8h0L10,15.7l3.9-7.4h0A4.8,4.8,0,0,0,14.3,6.5ZM9.5,4.2a.5.5,0,0,1,1,0V6.9a.5.5,0,0,1-1,0Z" fill="url(#myGradient)"/><text fill="#fff" style="font-size: 6px;font-weight: 700;transform: translate(8px, 9px);">' + stopsCount + '</text></svg>',
                                    html:
                                        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 386 512"><path fill="rgb(247, 59, 94)" stroke="#fff" stroke-width="30" d="M187.733 505.173L112.64 375.467c-3.413-6.827-6.827-10.24-13.653-17.067l-81.92-78.507C6.827 269.653 0 256 0 242.347V143.36c0-13.653 6.827-27.307 17.067-37.547l88.746-88.746C116.053 6.827 129.707 0 143.36 0h95.573c13.654 0 27.307 6.827 37.547 17.067l88.747 88.746c10.24 10.24 17.066 23.894 17.066 37.547v95.573c0 13.654-6.826 27.307-17.066 37.547l-81.92 81.92c-6.827 6.827-10.24 13.653-13.654 20.48L194.56 505.173c3.413 6.827-6.827 6.827-6.827 0z" class=""></path><text fill="#fff" x="' +
                                        (feature.stopsCount > 10 ? '20%' : '35%') +
                                        '">' +
                                        feature.stopsCount +
                                        '</text></svg>',
                                    className: 'stop-icon stop-icon-' + feature.stopsCount,
                                    iconSize: [26, 35],
                                    iconAnchor: [13, 35]
                                })
                            })

                            stopMarker.stopIndex = feature.stopsCount
                            stopMarker.extremes = [latlng, latlng]

                            stopMarker.on('click', this.stopMarkerClick)

                            return stopMarker
                        }
                    }
                }

                this.geojson = this.geojson.filter((g) => g.id != 'stops')

                this.geojson.push(geoJsonToSave)

                this.setStopsGeoJSON(geoJsonToSave)
            },
            drawActivities() {
                let lastpoint_company = this.truck?.lastpoint?.company

                this.setLoader({ activities: true })

                this.$fetch(
                    this.$env.GOLIA_API +
                    '/geofleet/trucks/' +
                    this.truck.id +
                    '/activities.json?start_date=' +
                    this.startDate +
                    '&end_date=' +
                    this.endDate +
                    '&company=' +
                    lastpoint_company
                )
                    .then((res) => {
                        return res.json()
                    })
                    .then((res) => {
                        this.setLoader({ activities: false })

                        if (!res.features) return

                        const geoJsonToSave = {
                            id: 'activities',
                            geojson: res,
                            options: {
                                pointToLayer: function (feature, latlng) {
                                    let html = ''

                                    if (feature.properties.activity == 0)
                                        html =
                                            '<svg id="Livello_2" data-name="Livello 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 16"><path stroke="black" stroke-width="3%" d="M17.2,7.2V9h0v5.2H15.3V9.1H4.9v5.2H3V2H4.9V7.2Z" fill="#ABDDA9"/></svg>'

                                    if (feature.properties.activity == 2)
                                        html =
                                            '<svg id="Livello_2" data-name="Livello 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 16"><path stroke="black" stroke-width="3%" d="M13.8,14l.2.2h.5l.5-.5.3-.4c.3-.4.3-.6,0-.9L11.6,8.7l1.8-1.9,1.7,1.7.3.3a.8.8,0,0,0,1-.2h0a17.3,17.3,0,0,0,.3-3.2L13.2,1.8h-.5L11,3.7a.6.6,0,0,0,.1.7l.6.7c-.6.6-1.1,1.2-1.7,1.7L8.3,5.1l.6-.6c.3-.4.3-.7,0-1L7.4,2l-.2-.2H6.8L3.2,5.4a11,11,0,0,0,.4,3.1.5.5,0,0,0,.5.5l.4-.2,1-.9A5.7,5.7,0,0,1,6.6,6.8,15.4,15.4,0,0,0,8.3,8.7L4.7,12.4a.6.6,0,0,0-.1.9l.8.9h.7l3.8-3.8H10Z" fill="#FC9E43"/></svg>'

                                    return L.marker(latlng, {
                                        icon: L.divIcon({
                                            html: html,
                                            className: '',
                                            iconSize: [26, 18],
                                            iconAnchor: [13, 9]
                                        })
                                    })
                                }
                            }
                        }

                        this.geojson = this.geojson.filter((g) => g.id != 'activities')

                        this.geojson.push(geoJsonToSave)

                        this.setActivitiesGeoJSON(geoJsonToSave)
                    })
            },
            resized(rect) {
                let width = (rect.width / 100) * 70

                if (this.$refs.activityChart && this.$refs.activityChart.charts)
                    this.$refs.activityChart.charts.map((c) => c.setSize(width, undefined, false))

                if (this.$refs.map && this.$refs.map.lmap) this.$refs.map.lmap.invalidateSize(true)
            },
            print() {
                this.loadingPrint = true

                let format = 'image' // 'image' - return base64, 'canvas' - return canvas
                let overridedPluginOptions = {
                    mimeType: 'image/png'
                }

                this.screenShooter
                    .takeScreen(format, overridedPluginOptions)
                    .then((blob) => {
                        this.screenshot = blob

                        // Wrap the PDF generation in a Promise
                        return this.$nextTick()
                            .then(() => {
                                return this.$refs.html2Pdf.generatePdf()
                            })
                            .finally(() => {
                                this.loadingPrint = false
                            })
                    })
                    .catch((e) => {
                        console.error(e)
                        this.loadingPrint = false
                    })
            },
            stopMarkerClick(e) {
                var segment = this.computedStops[e.sourceTarget.stopIndex - 1]

                if (!segment) return null

                var range = [
                    this.moment(segment.start_date).unix() * 1000,
                    this.moment(segment.end_date).unix() * 1000
                ]

                var bound = e.sourceTarget.extremes

                this.timelineSelected({ bound: bound, range: range })

                // Deseleziono le altre
                this.routeTimeline.timeline.map((segment) => {
                    segment.selected = false
                })

                // Seleziono il segmento nella timeline
                this.routeTimeline.timeline.find((t) => {
                    return t.start_date == segment.start_date
                }).selected = true
            },
            ...mapMutations({
                setLoader: 'activityPanel/setLoader',
                setCurrentTruck: 'activityPanel/setCurrentTruck',
                setRouteGeoJSON: 'activityPanel/setRouteGeoJSON',
                setStopsGeoJSON: 'activityPanel/setStopsGeoJSON',
                setActivitiesGeoJSON: 'activityPanel/setActivitiesGeoJSON',
                setActivities: 'activityPanel/setActivities',
                setStops: 'activityPanel/setStops',
                setLayers: 'activityPanel/setLayers',
                resetActivityPanel: 'activityPanel/resetState'
            }),
            handleShowRouteAction(newVal) {
                if (newVal) {
                    this.draw()
                } else {
                    this.resetData()
                }
            },
            handleTruckChange(newT, oldT) {
                if (newT.id === oldT?.id) return
                this.resetData()
                this.draw()
            },
            handleRangeChange() {
                this.resetData()
                this.draw()
            }
        }
    }
</script>

<style>
    .stop-icon text {
        transform: translateY(260px);
        font-size: 190px;
        font-weight: 700;
    }
</style>

<style scoped lang="scss">
    .btn-print {
        margin-right: 20px;
    }

    ::v-deep(.leaflet-popup-custom) {
        .leaflet-popup-content {
            margin-left: 10px;
        }

        a.leaflet-popup-close-button {
            top: 3px;
            right: 3px;
            background: var(--main-gray);
            border-radius: 50%;
        }

        .data-container {
            display: grid;
            grid-template-columns: repeat(2, 50%);
            column-gap: 10px;
        }
    }

    .route-analyzer {
        height: 100%;
        position: relative;
    }

    .chart-map {
        display: flex;
        flex-direction: column;
        flex-grow: 2;
        flex-basis: 70%;
    }

    .activity-chart {
        flex-basis: 35%;
    }

    .geofleet-map {
        flex-basis: 65%;
    }

    .timeline-wrapper {
        display: flex;
        flex-direction: column;
        flex-basis: 30%;
        position: relative;
    }

    .tachograph-activities {
        padding: 0 0 12px;
        border-bottom: 1px solid #e5e5e5;
    }

    .tacho-title-button {
        display: inline-flex;
        align-items: center;
        padding: 0;
        border: 0;
        background: transparent;
        color: inherit;
        cursor: pointer;
    }

    .tacho-title-button:hover .font-bold,
    .tacho-title-button:hover .tacho-title-button-info {
        color: var(--dark-blue, #65798e);
    }

    .tacho-title-button-info {
        font-size: 0.8rem;
        opacity: 0.7;
    }

    .timeline {
        overflow-y: scroll;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        /* flex-basis: 30%; */
    }

    .timeline-tools ::v-deep(.form-select),
    .timeline-tools ::v-deep(.form-control) {
        color: #333;
    }

    .timeline-content {
        cursor: pointer;
    }

    .timeline-content:hover {
        background-color: #edf3f9;
    }

    .timeline-filters-popover {
        right: 30px;
        top: 30px !important;
        left: initial !important;
        transform: none !important;
    }

    .pick-a-date {
        flex-grow: 2;
        justify-content: center;
        align-items: center;
        display: flex;
    }

    /* Media Query desktop > 1200 */
    @media (min-width: 1200px) {
        .chart-map {
            gap: 15px;
            padding-left: 15px;
            padding-bottom: 15px;
            padding-right: 15px;
        }

        .activity-chart,
        .geofleet-map {
            border-radius: 15px;
        }

        ::v-deep(.container ul) {
            margin-left: 0;
            padding-left: 0;
        }
    }

    ::v-deep(#chart-settings-modal) {
        .modal-footer {
            display: none;
        }
    }
</style>
